/*
 * Kanzi — cart drawer layer
 * ---------------------------------------------------------------
 * Scope: the SLIDE-OUT DRAWER only. The cart page has its own section
 * (sections/kanzi-cart.liquid) and this file must never touch it.
 *
 * Two jobs:
 *   1. Free-delivery progress inside the drawer — the highest-leverage
 *      AOV nudge, shown where most mobile shoppers actually see the cart.
 *   2. Make the drawer closeable no matter what: the theme's X, the
 *      backdrop, and Escape.
 *
 * TWO RULES LEARNED THE HARD WAY:
 *  - Nothing runs on page load. Injecting into the page after a fetch
 *    is what made things visibly jump around a second after loading.
 *    Everything here waits until the drawer is opened.
 *  - No [class*="..."] selectors. Only classes read off the theme's own
 *    markup: cart-drawer__dialog, cart-drawer__summary, cart-drawer__inner.
 */
(function () {
  var KZ = window.KZ || {};
  if (typeof KZ.money !== 'function') return; // kanzi-money.liquid missing

  var THRESHOLD_KD = KZ.freeShipping || 0;

  function dialog() {
    return document.querySelector('dialog.cart-drawer__dialog');
  }

  /* ── free delivery progress ─────────────────────────────────── */
  /* Guard: this function writes into the drawer, and we also WATCH the
     drawer for changes. Without the flag each render would trigger the
     observer that triggered it — an endless fetch loop. */
  var writing = false;

  function renderShipping(dlg) {
    if (!THRESHOLD_KD || writing) return;
    writing = true;
    var host = dlg.querySelector('.cart-drawer__summary') || dlg.querySelector('.cart-drawer__inner');
    if (!host) { writing = false; return; }

    var box = host.querySelector('.kz-ship');
    if (!box) {
      box = document.createElement('div');
      box.className = 'kz-ship';
      box.innerHTML =
        '<p class="kz-ship__text"></p>' +
        '<div class="kz-ship__bar"><div class="kz-ship__fill" style="width:0"></div></div>';
      host.insertBefore(box, host.firstChild);
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var target = THRESHOLD_KD * KZ.divisor;
        var total = cart.total_price;
        var left = target - total;
        var pct = Math.max(0, Math.min(100, (total / target) * 100));
        box.querySelector('.kz-ship__text').innerHTML = left > 0
          ? 'Spend <b>' + KZ.money(left) + '</b> more for free delivery'
          : '<b>Free delivery unlocked.</b>';
        box.querySelector('.kz-ship__fill').style.width = pct + '%';
        box.classList.toggle('is-done', left <= 0);
        box.hidden = false;
      })
      .catch(function () { box.hidden = true; })
      .then(function () { setTimeout(function () { writing = false; }, 60); });
  }

  /* ── trust, in the pinned footer where the money is ─────────── */
  var TRUST = KZ.trust || ['Next-day delivery in Kuwait', 'Free size exchange', 'KNet, cards and cash on delivery'];

  function renderTrust(dlg) {
    var host = dlg.querySelector('.cart-drawer__summary');
    if (!host || host.querySelector('.kz-cart-trust')) return;
    var row = document.createElement('div');
    row.className = 'kz-cart-trust';
    TRUST.forEach(function (t) {
      var s = document.createElement('span');
      s.textContent = t;
      row.appendChild(s);
    });
    host.appendChild(row);
  }

  /* ── the bag is an overlay, never a page ────────────────────────
     A cart on its own URL arrives wrapped in the announcement bar, the
     header and the footer. Anything pointing at /cart opens the panel
     instead — the shopper stays exactly where they were. */
  var cartLinksWired = false;
  function interceptCartLinks() {
    if (cartLinksWired) return;      // called from observers too; wire once
    cartLinksWired = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href$="/cart"], a[href*="/cart?"]');
      if (!a) return;
      var dlg = dialog();
      if (!dlg) return;                       // no panel on this page: let it navigate
      e.preventDefault();
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) trigger.click();
      else if (typeof dlg.showModal === 'function' && !dlg.open) dlg.showModal();
    }, true);
  }

  /* ── make sure it can always be closed ──────────────────────── */
  function close(dlg) {
    var btn = dlg.querySelector('.cart-drawer__close-button');
    if (btn) { btn.click(); return; }        // let the theme run its own teardown
    if (typeof dlg.close === 'function') dlg.close();
  }

  function wireClosing(dlg) {
    if (dlg.dataset.kzClose === '1') return;
    dlg.dataset.kzClose = '1';

    // clicking the dark area outside the panel
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) close(dlg);
    });

    // Escape, even if something swallowed the native cancel event
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var d = dialog();
      if (d && d.open) close(d);
    });
  }

  /* ── react to the drawer opening ────────────────────────────── */
  function boot() {
    var dlg = dialog();
    if (!dlg) return;
    wireClosing(dlg);

    interceptCartLinks();
    if (dlg.open) { renderShipping(dlg); renderTrust(dlg); }

    new MutationObserver(function () {
      if (dlg.open) { renderShipping(dlg); renderTrust(dlg); }
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    // the drawer re-renders its contents after add/qty changes
    new MutationObserver(function () {
      if (dlg.open) { renderShipping(dlg); renderTrust(dlg); }
    }).observe(dlg, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* The drawer is server-rendered in header-actions.liquid, so it is in
     the document before this script runs. The observer that used to sit
     here watched documentElement with subtree:true for the entire life
     of every page, purely to catch a case that does not happen. One
     retry covers a slow theme boot at a fraction of the cost. */
  if (!dialog()) setTimeout(boot, 600);
})();
